/* eslint-disable */
import { produce } from "immer";
import {
  PRODUCT_OVERVIEW_FETCH_START,
  PRODUCT_OVERVIEW_FETCH_SUCCESS,
  PRODUCT_OVERVIEW_FETCH_FAILURE,
} from "../actions/types";

const productOverview = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case PRODUCT_OVERVIEW_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case PRODUCT_OVERVIEW_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case PRODUCT_OVERVIEW_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default productOverview;
